module.exports = __webpack_public_path__ + "static/media/conner-bg.fafde5fa.mp4";